<template>
    <div class="homePage">
        <div class="banner">
            <!--            <img :src="logoUrl" alt="">-->
            <h1 style="letter-spacing:6px;font-weight:bolder;font-size: 42px;-webkit-text-stroke:1px #ffffff;color: #e14e2a;text-shadow:2px 0  #ffffff;font-style: oblique">
                {{textTitle}}
            </h1>
            <h2 style="letter-spacing:3px;font-size: 16px;color:#E43131;-webkit-text-stroke:1px #ffffff;">
                {{' Public service platform of housing special maintenance funds'.toUpperCase() }}
            </h2>
        </div>

        <!--tbas选项-->
        <div class="tabsBox" v-if="table_flag">
            <ul class="uls">
                <li class="lis" :class="tabLisActive ==index?'active':''" v-for="(item,index) in tabLis" :key="index"
                    @click="tabClick(index,item.title)">{{item.title}}
                </li>
            </ul>
        </div>

        <!--内容-->
        <div class="contentBox">
            <div class="con">
                <router-view v-if="pageFlag" class="conPage" @tablePage="tablePage"></router-view>
            </div>
        </div>


        <!--底部-->
        <div class="footer">
            <div class="con">
                <div class="lis bottom">
                    <p>技术支持：甘肃环讯信息科技有限公司 </p>
                    <p>联系电话：0931-8121096</p>
                    <p> 陇ICP备19001769号-4</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import urljson from "../../static/json/url.json";

    export default {
        name: "home",
        data() {
            return {
                table_flag: true,
                pageFlag: true,
                tabLisActive: 0,
                tabLis: [
                    {
                        id: 0,
                        title: '首页'
                    },
                   /* {
                        id: 1,
                        title: '中心简介'
                    },*/
                    {
                        id: 2,
                        title: '政策法规'
                    },
                    {
                        id: 3,
                        title: '新闻动态'
                    },
                    {
                        id: 4,
                        title: '通知公告'
                    },
                    {
                        id: 5,
                        title: '维修指南'
                    },
                    {
                        id: 6,
                        title: '服务指南'
                    },
                    {
                        id: 7,
                        title: '下载中心'
                    },
                ],
                logoUrl: require('../../../public/image/home/logo.png'),
                textTitle: ''
            }

        },

        watch: {
            tabFlag(value) {
                this.table_flag = value
            },
        },


        computed: {
            tabFlag() {
                return this.$store.state.tabFlag
            }
        },

        mounted(){
            this.table_flag = this.$store.state.tabFlag;

        },

        created() {
            const that = this;
            if (localStorage.getItem("token") == "" || localStorage.getItem("token") == null) {
                let urldata = urljson;
                let url = window.location.href;
                //循环
                urldata.forEach((value, key) => {
                    if (url.indexOf(value.key) >= 0) {
                        that.textTitle = value.name;
                        localStorage.setItem("client_id", value.client_id);
                        this.client_id = localStorage.getItem("client_id");
                        return false;
                    }
                });
            }else{
                let urldata = urljson;
                let  url = window.location.href;
                urldata.forEach((value, key) => {
                    if (url.indexOf(value.key) >= 0) {
                        that.textTitle = value.name;
                        return false;
                    }
                });
            }
        },
        methods: {
            tabClick(index, title) {
                this.pageFlag = false;
                this.$nextTick(() => {
                    this.pageFlag = true;
                    this.tabLisActive = index;
                    if (title == "首页") {
                        this.$router.push({path: '/homeContent'})
                    } else if (title == "中心简介") {
                        this.$router.push({
                            path: '/policyDetails',
                            query: {
                                title: '下载中心'
                            }
                        })
                    } else {
                        this.$router.push({path: '/policy', query: {title: title}})
                    }
                })
            },

            tablePage(item) {
                this.tabLis.forEach((el, index) => {
                    if (el.title == item) {
                        this.tabLisActive = index;
                    }
                });
            }
        }


    }
</script>

<style scoped lang="scss">
    .homePage {
        width: 100%;
        min-height: 100vh;
        .banner {
            width: 100%;
            height: 196px;
            background: url("../../../public/image/home/bg.jpg");
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            h1 {
                margin-left: -19%;
            }
            h2 {
                margin-left: -19%;
                margin-top: 5px;
            }
        }
        .tabsBox {
            width: 100%;
            height: 44px;
            background: #2e71c9;
            .uls {
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                .lis {
                    font-size: 14px;
                    color: #fff;
                    list-style: none;
                    width: 136px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    &:hover {
                        background: #1e4f90;
                    }
                }
                .lis.active {
                    background: #1e4f90;
                }
            }
        }

        .contentBox {
            width: 100%;
            min-height: 578px;
            background: #fff url("../../../public/image/home/jb.png") no-repeat top;
            background-size: 100%;
            padding-bottom: 75px;
            .con {
                width: 1200px;
                margin: 0 auto;
                background: #fff;
                .conPage {
                    width: 1000px;
                    margin: 0 auto;
                    position: relative;
                }
            }
        }

        .footer {
            width: 100%;
            height: 118px;
            background: #fff;
            border-top: 2px solid #2e71c9;
            .con {
                width: 1200px;
                height: 100%;
                margin: 0 auto;
                font-family: PingFang SC;
                color: #333333;
                font-size: 12px;
                line-height: 29px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .lis {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .top {
                    p:nth-of-type(2) {
                        margin-left: 50px;
                    }
                }
                .bottom {
                    p:nth-of-type(2) {
                        margin-left: 50px;
                    }
                    p:nth-of-type(3) {
                        margin-left: 50px;
                    }
                }
            }
        }
    }
</style>
